var idify = function idify() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.toString().replace(/ /g, '-').toLowerCase();
};

export default idify;